var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.062 13.439-4.587-4.585a3.583 3.583 0 0 0-4.95 0L4.94 13.439a1.5 1.5 0 0 0 2.122 2.121l4.587-4.585a.5.5 0 0 1 .707 0l4.584 4.586a1.5 1.5 0 1 0 2.122-2.123"
  })));
};
export default SvgChevronUp;